import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Modal, Button, Form, notification, Col, Row } from "antd";

import FloatInput from "../../../../providers/FloatInput";
import { POST, GET } from "../../../../providers/useAxiosQuery";
import validateRules from "../../../../providers/validateRules";
import FloatInputMask from "../../../../providers/FloatInputMask";
import FloatSelect from "../../../../providers/FloatSelect";

export default function ModalEditAuthor(props) {
	const { toggleModalEditAuthor, setToggleModalEditAuthor, course, role } =
		props;

	// console.log("course", course);
	// console.log("role", role);
	const [form] = Form.useForm();
	const params = useParams();

	const { mutate: mutateEmail, loading: loadingEmail } = POST(
		`api/update_author`,
		[`authors_list_${toggleModalEditAuthor.book_id}`, "profiles"]
	);

	const onFinish = (values) => {
		console.log("onFinish", values);

		let data = {
			...values,

			id:
				toggleModalEditAuthor &&
				toggleModalEditAuthor.data &&
				toggleModalEditAuthor.data.id,

			book_id: toggleModalEditAuthor.book_id,
		};

		mutateEmail(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Author Added",
						description: res.message,
					});

					setToggleModalEditAuthor({ open: false, data: null });

					form.resetFields();
				} else {
					notification.error({
						message: "Something went wrong",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notification.error({
					message: "Author not successfully Added",
					description: "Something went Wrong",
				});
			},
		});
	};

	useEffect(() => {
		if (toggleModalEditAuthor.open) {
			if (toggleModalEditAuthor.data) {
				let data = {
					...toggleModalEditAuthor.data,
					email: toggleModalEditAuthor.data.user.email,
				};
				form.setFieldsValue(data);
			}
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggleModalEditAuthor]);

	return (
		<Modal
			width="900px"
			title="Add Author"
			open={toggleModalEditAuthor.open}
			onCancel={() => {
				setToggleModalEditAuthor({
					open: false,
					data: null,
				});
			}}
			footer={[
				<Button
					className="btn-main-primary outlined"
					size="large"
					key={1}
					onClick={() => {
						setToggleModalEditAuthor({
							open: false,
							data: null,
						});
						form.resetFields();
					}}
				>
					CANCEL
				</Button>,
				<Button
					className="btn-main-primary"
					type="primary"
					size="large"
					key={2}
					onClick={(values) => form.submit(values)}
					loading={loadingEmail}
				>
					SUBMIT
				</Button>,
			]}
		>
			<Form form={form} onFinish={onFinish}>
				<Row gutter={[12, 0]}>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item name="firstname" rules={[validateRules.required]}>
							<FloatInput label="Firstname" placeholder="Firstname" required />
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item name="middlename">
							<FloatInput label="Middlename" placeholder="Middlename" />
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item name="lastname" rules={[validateRules.required]}>
							<FloatInput label="Lastname" placeholder="Lastname" required />
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item name="suffix">
							<FloatInput label="Suffix" placeholder="Suffix" />
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item name="role_id" rules={[validateRules.required]}>
							<FloatSelect
								label="Role"
								placeholder="Role"
								required
								options={
									role
										? role.data.map((item) => ({
												value: item.id,
												label: item.author_role,
										  }))
										: []
								}
							/>
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item
							name="email"
							rules={[validateRules.required, validateRules.email]}
						>
							<FloatInput
								label="Email Address"
								placeholder="Email Address"
								required
							/>
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item
							name="school_id"
							rules={[
								{
									min: 3,
									max: 11,
									message: "Invalid School ID",
								},
								validateRules.required,
								validateRules.number,
							]}
						>
							<FloatInputMask
								label="School ID Number"
								placeholder="School ID Number"
								required
								maskType="99999999999"
							/>
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item name="contact" rules={[validateRules.required]}>
							<FloatInputMask
								label="Phone No"
								placeholder="Phone No"
								maskLabel="contact_number"
								maskType="(+63) 999 999 9999"
								required
							/>
						</Form.Item>
					</Col>

					<Col xs={24} sm={24} md={12} lg={12} xl={24}>
						<Form.Item name="course_id" rules={[validateRules.required]}>
							<FloatSelect
								label="Course"
								placeholder="Course"
								required
								options={
									course
										? course.data.map((item) => ({
												value: item.id,
												label: item.course_name,
										  }))
										: []
								}
							/>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
}
